const ORDER_TYPES = {
  ANY_TYPE: 0,
  WALK_TYPE: 1,
  CLICK_TYPE: 2,
  CALL_TYPE: 3,
};

export default ORDER_TYPES;
